import { animate, query, sequence, style, transition, trigger, } from '@angular/animations';

const TIMMING = '150ms ease-out';
export const BUTTON_ANIM = trigger('fade', [
  transition('idle => loading', [
    sequence([
      query('.icon', [
        style({ width: 0, opacity: 0, marginRight: 0 }),
        animate(TIMMING, style({ width: '16px', marginRight: '5px' })),
        animate(TIMMING, style({ opacity: 1 })),
        style({ opacity: 1, width: '20px', marginRight: '5px' }),
      ]),
    ]),
  ]),
  transition('loading => idle', [
    sequence([
      query('.icon', [
        style({ opacity: 1, width: '16px', marginRight: '5px' }),
        animate(TIMMING, style({ opacity: 0 })),
        animate(TIMMING, style({ width: '0', marginRight: '0' })),
      ]),
    ]),
  ]),
]);
